// Check if a string represents a JavaScript function
export default function isFunctionString(str: string): boolean {
  const arrowFunctionRegex = /^\s*(\(.*\)|[a-zA-Z0-9_$]+)\s*=>/;
  const traditionalFunctionRegex = /^\s*function\s*\(.*\)\s*\{/;

  return arrowFunctionRegex.test(str) || traditionalFunctionRegex.test(str);
}
